import { TFunction } from "i18next";
import { z } from "zod";
import { nullableNumber } from "../../../utils";

export const getLithologyFormSchema = (t: TFunction) => {
  const numberField = nullableNumber(t("generic.errors.invalid-number"));
  return z.object({
    startDepth: z
      .number({
        required_error: t("captures.capture.lithology.errors.start-depth-required"),
        invalid_type_error: t("captures.capture.lithology.errors.start-depth-required"),
      }),
    endDepth: z
      .number({
        required_error: t("captures.capture.lithology.errors.end-depth-required"),
        invalid_type_error: t("captures.capture.lithology.errors.end-depth-required"),
      }),
    lithologyId: z
      .number({
        required_error: t("captures.capture.lithology.errors.lithology-required"),
        invalid_type_error: t("captures.capture.lithology.errors.lithology-required"),
      }),
    hydraulicConductivity: numberField.optional(),
    drillingAdvanceRate: numberField.optional(),
    secondaryFeatureId: z.number().nullable().optional(),
    textureId: z.number().nullable().optional(),
    colorId: z.number().nullable().optional(),
    aquiferId: z.number().nullable().optional(),
    notes: z.string().nullable().optional(),
  });
};

export type LithologyForm = z.infer<ReturnType<typeof getLithologyFormSchema>>;